import { render, staticRenderFns } from "./MessageReport.vue?vue&type=template&id=952001ba&scoped=true&"
import script from "./MessageReport.vue?vue&type=script&lang=js&"
export * from "./MessageReport.vue?vue&type=script&lang=js&"
import style0 from "./MessageReport.vue?vue&type=style&index=0&id=952001ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952001ba",
  null
  
)

export default component.exports